import React from 'react';
import {Container, Paper, Box, Button, Typography, TextField} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';


const SearchBox = ({
    searchLable,
    searchTerm,
    handleInputChange,
    handleSearch,
    handleReset,
    children
}) => {
    return (
        <Paper elevation={3} sx={{ padding: '20px', marginBottom: '20px', marginTop: '20px' }}>
            <Box
                sx={{
                        position: 'absolute',
                        backgroundColor: '#D81B60',
                        width: '35px',
                        height: '35px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '8px',
                        boxShadow: 3,
                    }}
            >
                <SearchIcon sx={{ fontSize: 30, color: '#fff' }} />
            </Box>
            <Box  spacing={2} alignItems="center">
                <Box  xs={12} sx={{paddingLeft:'45px'}}>
                    <Typography variant='h6' gutterBottom style={{fontWeight:'bold'}}>
                        Search
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '16px',
                    marginTop: '15px'
                }}
            >
                <TextField
                    fullWidth
                    label={searchLable}
                    variant="standard"
                    value={searchTerm || ''}
                    onChange={handleInputChange}
                    onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                />
                {children}
            </Box>
            <Box sx={{ display: 'flex', gap: '16px', marginTop: '20px' }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ fontWeight: 'bold' }}
                    onClick={handleSearch}
                >
                    Search
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    size="large"
                    style={{ fontWeight: 'bold' }}
                    onClick={handleReset}
                >
                    Reset
                </Button>
            </Box>
        </Paper>
    )
}

export default SearchBox;